import { render, staticRenderFns } from "./VideoBlock.vue?vue&type=template&id=292a0c9c&scoped=true"
import script from "./VideoBlock.vue?vue&type=script&lang=js"
export * from "./VideoBlock.vue?vue&type=script&lang=js"
import style0 from "./VideoBlock.vue?vue&type=style&index=0&id=292a0c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292a0c9c",
  null
  
)

export default component.exports